import { IProgramItemsWithGroupQuery } from '../interfaces/program-items-with-group.query.interface';
import { ProgramItemGroup } from './program-item-group.model';
import { ProgramItem } from './program-item.model';

// @dynamic
export class ProgramItemsWithGroup {
    id: string;
    group: ProgramItemGroup;
    programItems: ProgramItem[];
    groupStatsCoursesBooked: number;
    groupStatsCoursesCompleted: number;
    isExpanded: boolean;

    constructor(query: IProgramItemsWithGroupQuery, courseOfferingId?: string) {
        this.id = courseOfferingId ? courseOfferingId : null;
        this.group = query.group ? new ProgramItemGroup(query.group) : null;

        if (query.program_items) {
            this.programItems = query.program_items.length ? query.program_items.map((programItem) => new ProgramItem(programItem)) : [];
            this.isExpanded = query.program_items.length ? query.program_items.some((programItem) => programItem.course_progress_status === 'in_progress') : false;
            this.groupStatsCoursesBooked = query.group_stats_courses_booked;
            this.groupStatsCoursesCompleted = query.group_stats_courses_completed;
        }
    }
}
